module.exports = __webpack_public_path__ + "img/batalla.cd27a804.jpg";